import countries from 'i18n-iso-countries';

import { DataGenerator } from '@fino/lib-data-generator';
import ng1PromiseDecorator from '@fino/ng1-promise-decorator';

import { FormFieldsService } from './form-fields.service';
import { FormFieldsProvider } from './form-fields.provider';
import { formFieldsComponent } from './form-fields.component';
import { TYPES } from './form-fields.constants';

// Templates
import fdFormFieldsDescriptionTemplate from './partials/field-descriptions.html';

export default angular
  .module('ng1-form-fields', [ng1PromiseDecorator])
  .constant('countries', countries)
  .constant('fdFormTypes', TYPES)
  .service('dataGenerator', DataGenerator)
  .service('fdFormFieldsService', FormFieldsService)
  .provider('fdFormFields', FormFieldsProvider)
  .component('fdFormFields', formFieldsComponent)
  .constant('fdFormFieldsDescriptionTemplatePath', 'partials/field-descriptions.html')
  .run(($templateCache, fdFormFieldsDescriptionTemplatePath) => {
    'ngInject';
    $templateCache.put(fdFormFieldsDescriptionTemplatePath, fdFormFieldsDescriptionTemplate);
  })
  .name;
